<template lang="pug">
.review-section
  .testimonials(v-if="commentList.length > 0")
    .title-div.faq
      .title-wrap
        span.title-text TESTIMONIALS
      img.btn.view-more(src='/new/img/home/view more button.webp' alt='view more' @click="$router.push('/review').catch(err => {})")
    #testimonialsList.testimonials-list
      .testimonial-card(v-for="comment in commentList")
        img.testimonial-card-bg(src="/new/img/home/bar.webp")
        .testimonial-card-body
          .testimonial-card-header
            img.testimonial-avatar(src="/new/img/home/user profile.webp")
            .testimonial-meta
              .testimonial-user
                p.testimonial-username {{comment.account_id}}
                p.testimonial-date {{$moment(comment.created_date).format('D MMMM YYYY')}}
              img.testimonial-stars-img(:src="`/new/img/home/${comment.rating}.webp`")
          p.testimonial-text {{comment.comment}}
</template>
<script>
export default{
  data(){
    return{
      commentList: []
    }
  },
  mounted(){
    this.reviewList()
  },
  methods:{
    reviewList(){
      let page_number = 1
      this.$store
        .dispatch("user/reviewList", {page_number})
        .then(response => {
          if (response.success == true) {
            this.commentList = response.data.slice(0,3)
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          }
        })
        .catch(response => {
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
          }
        });
    },
  }
}
</script>
<style lang="scss" scoped>
.review-section{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.view-more{
  max-width: 198px;
}
.title-div {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // padding: 16px;
}
.title-div img {
  @media(max-width: 767px){
    width: 35%;
  }
  
}
.testimonials-list {
  // padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.testimonial-card {
  position: relative;
  width: 100%;
}

.testimonial-card-bg {
  width: 100%;
  height: 100px;
  display: block;
}

.testimonial-card-body {
  position: absolute;
  inset: 0;
  padding: 10px 20px;
  overflow: hidden;
  @media(max-width: 767px){
    padding: 10px 12px;
  }
}

.testimonial-card-header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.testimonial-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  flex-shrink: 0;
}

.testimonial-meta {
  flex: 1;
  min-width: 0;
  padding: 4px 0;
}

.testimonial-user {
  display: flex;
  align-items: center;
  gap: 4px;
  p{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
}

.testimonial-username {
  font-family: "Bebas Neue", sans-serif;
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  line-height: 1;
  @media (max-width: 767px) {
    font-size: 12px;
  }
}

.testimonial-date {
  font-family: "Montserrat", sans-serif;
  font-weight: 300;
  color: #fff;
  font-size: 9px;
  margin-bottom: 10px !important;
  margin-left: 5px !important;
  @media (max-width: 767px) {
    font-size: 7.5px;
    margin-bottom: 8px !important;
    margin-left: 3px !important;
  }
}

.testimonial-stars-img {
  width: 80px;
  display: block;
  margin-left: -4px;
}

.testimonial-text {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  color: #fff;
  font-size: 15px;
  line-height: 1.45;
  margin-top: 7px;
  @media (max-width:767px) {
    font-size: 12px;
  }
}
</style>